/**
 * CSSC Utilities Module
 *
 * Contains utility functions for CSSC operations
 */
/**
 * Validates that a campaign code matches the expected format (7-10 digits).
 *
 * @param value - The campaign code string to validate
 * @returns The validated campaign code if valid, null otherwise
 */
export var validateCampaignCode = function (value) {
    if (!value)
        return null;
    // For valid campaign code validation, must be 7-10 digits
    if (!/^\d{7,10}$/.test(value)) {
        return null;
    }
    return value;
};
/**
 * Sets the campaign cookie with the given value, but only if the value has changed
 * or no cookie currently exists. This optimizes performance by avoiding unnecessary
 * cookie writes that would reset the expiration date.
 *
 * @param value - The campaign code value to set in the cookie
 * @param currentKnownCookieValue - The currently known cookie value for comparison (optional)
 */
export var setCampaignCookie = function (value, currentKnownCookieValue) {
    if (currentKnownCookieValue === void 0) { currentKnownCookieValue = null; }
    if (currentKnownCookieValue === value)
        return;
    var date = new Date();
    date.setTime(date.getTime() + 6 * 30 * 24 * 60 * 60 * 1000); // 6 months (approx)
    document.cookie = "campaign=".concat(encodeURIComponent(value), ";expires=").concat(date.toUTCString(), ";path=/;domain=worldvision.org;SameSite=Lax");
};
/**
 * Retrieves the current campaign cookie value.
 *
 * @returns The decoded campaign cookie value, or null if no campaign cookie exists
 */
export var getCampaignCookie = function () {
    var cookieMatch = document.cookie.match(/(?:^|;\s*)campaign=([^;]*)/);
    return cookieMatch ? decodeURIComponent(cookieMatch[1]) : null;
};
/**
 * Retrieves a query parameter value from the current URL, with case-insensitive matching.
 *
 * @param name - The name of the query parameter to retrieve
 * @returns The query parameter value, or null if not found
 */
export var getQueryParam = function (name) {
    var params = new URLSearchParams(window.location.search);
    // Case insensitive parameter name matching
    var paramName = Array.from(params.keys()).find(function (key) { return key.toLowerCase() === name.toLowerCase(); });
    return paramName ? params.get(paramName) : null;
};
